/**
 * Tresor ID is read-only when the garage API says Kadensis still syncs it.
 * The create page has no garage, so a missing `sync` flag leaves the field editable.
 *
 * @param {{ sync?: boolean } | null | undefined} garage
 * @returns {boolean}
 */
export function isTresorIdReadOnly(garage) {
  return Boolean(garage && garage.sync);
}
